import type {
  EbookLearningAttempt,
  EbookLearningProgress,
  EbookQuestionProgress,
} from '@wx-weiqi/contracts';

export type EbookLearningFilter = 'ALL' | 'UNSEEN' | 'REVIEW';
export function learningQuestionIds(
  ids: string[],
  progress: EbookQuestionProgress[],
  filter: EbookLearningFilter,
) {
  const lookup = new Map(progress.map((p) => [p.questionId, p]));
  return ids.filter(
    (id) =>
      filter === 'ALL' ||
      (filter === 'UNSEEN'
        ? !lookup.get(id)?.completedCount
        : lookup.get(id)?.reviewState === 'DUE'),
  );
}
export function continueQuestion(ids: string[], progress: EbookLearningProgress | null) {
  if (progress?.resume && !progress.resume.submitted) return progress.resume.questionId;
  const unseen = learningQuestionIds(ids, progress?.questions ?? [], 'UNSEEN');
  const lastIndex = ids.indexOf(progress?.resume?.questionId ?? '');
  return unseen.find((id) => ids.indexOf(id) > lastIndex) ?? unseen[0] ?? null;
}
export function learningResult(a: EbookLearningAttempt | null) {
  if (!a) return '尚未完成';
  if (a.demonstrated) return '看过答案';
  if (!a.submitted) return '作答中';
  const text = a.status === 'CORRECT' ? '答对' : a.status === 'INCORRECT' ? '答错' : '待批改';
  return a.hinted ? `${text}（使用提示）` : text;
}
export function reviewLabel(p: EbookQuestionProgress) {
  if (p.reviewState === 'DUE') return '待复习';
  if (p.reviewState === 'MASTERED') return '复习已掌握';
  if (p.reviewState === 'SCHEDULED' && p.nextReviewAt)
    return `${new Date(p.nextReviewAt).toLocaleDateString('zh-CN', { month: 'numeric', day: 'numeric' })} 再复习`;
  return p.completedCount ? '已练习' : '作答中';
}
